import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';

import { AlcoholicDrinkType } from 'src/app/products/interfaces/models';
import { SubformBaseComponent } from 'src/app/shared/components/subform-base/subform-base.component';

import { AlcoholicDrinkProperties } from '@app/api/marketplace/models';

import { BeerPropertiesSubformComponent } from '../beer/beer-properties-subform/beer-properties-subform.component';
import { ChampagnePropertiesSubformComponent } from '../champagne/champagne-properties-subform/champagne-properties-subform.component';
import { GrapeWinePropertiesSubformComponent } from '../grape-wine/grape-wine-properties-subform/grape-wine-properties-subform.component';
import { OtherAlcoholPropertiesSubformComponent } from '../other-alcohol/other-alcohol-properties-subform/other-alcohol-properties-subform.component';
import { SpiritPropertiesSubformComponent } from '../spirit/spirit-properties-subform/spirit-properties-subform.component';

const ALCOHOL_FREE_TRESHOLD = 0.5;
const ALCOHOL_FREE_VALIDATORS = [
  Validators.min(0),
  Validators.max(0.5),
  Validators.required,
];
const ALCOHOLIC_VALIDATORS = [
  Validators.min(0.6),
  Validators.max(100),
  Validators.required,
];

@Component({
  selector: 'app-alcoholic-drink-properties-subform',
  templateUrl: './alcoholic-drink-properties-subform.component.html',
  styleUrls: ['./alcoholic-drink-properties-subform.component.scss'],
})
export class AlcoholicDrinkPropertiesSubformComponent extends SubformBaseComponent {
  DICT_PATH = 'PRODUCTS.ALCOHOLIC_DRINK_PROPERTIES';

  static buildForm(
    fb: FormBuilder,
    selectedType: AlcoholicDrinkType,
    data: AlcoholicDrinkProperties | undefined,
    isSecondaryProductSheet: boolean
  ) {
    const isAlcoholFree =
      data?.alcoholLevel !== undefined &&
      data?.alcoholLevel <= ALCOHOL_FREE_TRESHOLD;

    return fb.group({
      alcoholLevel: fb.control(
        data?.alcoholLevel ?? 0.6,
        isAlcoholFree ? ALCOHOL_FREE_VALIDATORS : ALCOHOLIC_VALIDATORS
      ),
      ...(selectedType == AlcoholicDrinkType.Beer && {
        beerProperties: BeerPropertiesSubformComponent.buildForm(
          fb,
          data?.beerProperties,
          isSecondaryProductSheet
        ),
      }),
      ...(selectedType == AlcoholicDrinkType.GrapeWine && {
        grapeWineProperties: GrapeWinePropertiesSubformComponent.buildForm(
          fb,
          data?.grapeWineProperties,
          isSecondaryProductSheet
        ),
      }),
      ...(selectedType == AlcoholicDrinkType.Spirit && {
        spiritProperties: SpiritPropertiesSubformComponent.buildForm(
          fb,
          data?.spiritProperties,
          isSecondaryProductSheet
        ),
      }),
      ...(selectedType == AlcoholicDrinkType.Champagne && {
        champagneProperties: ChampagnePropertiesSubformComponent.buildForm(
          fb,
          data?.champagneProperties
        ),
      }),
      ...(selectedType == AlcoholicDrinkType.Other && {
        otherAlcoholProperties:
          OtherAlcoholPropertiesSubformComponent.buildForm(
            fb,
            data?.otherAlcoholProperties
          ),
      }),
      ...((selectedType === AlcoholicDrinkType.Champagne ||
        selectedType === AlcoholicDrinkType.Beer) && {
        alcoholFree: [isAlcoholFree],
      }),
    });
  }
}
